import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Icon from 'tbk-components/src/components/Icon';
export interface TileItems {
	/**
	 * Tile Item Heading
	 */
	heading?: string;
	/**
	 * Tile Item Text
	 */
	text?: string;
}
export interface ListItems {
	/**
	 * Tile Item Icon
	 */
	icon?: string;
	/**
	 * Tile Item Text
	 */
	text?: string;
}

export interface IAtAGlanceProps extends IBaseElementProps {
	/**
	 *  At A Glance Heading
	 */
	heading?: string;
	/**
	 *  At A Glance Tile Items
	 */
	tileItems?: TileItems[];
	/**
	 *  At A Glance Tile Content Heading
	 */
	contentHeading?: string;
	/**
	 *  At A Glance Tile Content Text
	 */
	contentText?: string;
	/**
	 *  At A Glance List Heading
	 */
	listHeading?: string;
	/**
	 *  At A Glance List Items
	 */
	listItems?: ListItems[];
}

/**
 * At A Glance
 * @block
 * @icon visibility
 */
const AtAGlance: React.FC<IAtAGlanceProps> = ({
	heading,
	tileItems = [],
	contentHeading,
	contentText,
	listHeading,
	listItems = [],
	id,
	className,
	classNames = [],
}) => (
	<div
		id={id}
		className={className || cn('calian-at-a-glance', ...classNames)}
	>
		<div className="calian-at-a-glance__container">
			<div className="calian-at-a-glance__wrapper">
				<div className="calian-at-a-glance__left">
					{heading && (
						<h2 className="calian-at-a-glance__heading">
							{heading}
						</h2>
					)}
					{tileItems.length > 0 && (
						<ul className="calian-at-a-glance__tile-items">
							{tileItems.map(({ heading, text }, index) => (
								<li
									className="calian-at-a-glance__tile-item"
									key={index}
								>
									{heading && (
										<div className="calian-at-a-glance__tile-heading">
											{heading}
										</div>
									)}
									{text && (
										<p className="calian-at-a-glance__tile-text">
											{text}
										</p>
									)}
								</li>
							))}
						</ul>
					)}
				</div>
				<div className="calian-at-a-glance__right">
					<div className="calian-at-a-glance__content">
						{contentHeading && (
							<h4 className="calian-at-a-glance__subheading">
								{contentHeading}
							</h4>
						)}
						{contentText && (
							<p className="calian-at-a-glance__content-text">
								{contentText}
							</p>
						)}
					</div>
					{listHeading && (
						<h4 className="calian-at-a-glance__subheading calian-at-a-glance__subheading--list">
							{listHeading}
						</h4>
					)}
					{listItems.length > 0 && (
						<ul className="calian-at-a-glance__list-items">
							{listItems.map(({ icon, text }, index) => (
								<li
									className="calian-at-a-glance__list-item"
									key={index}
								>
									{icon && (
										<span className="calian-at-a-glance__list-icon">
											<Icon name={icon} />
										</span>
									)}
									{text && (
										<span className="calian-at-a-glance__list-text">
											{text}
										</span>
									)}
								</li>
							))}
						</ul>
					)}
				</div>
			</div>
		</div>
	</div>
);

export default AtAGlance;
